module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_photowedding@2x-19d24c8bac447af844536ac328ce6934.webp";